import { useTranslation } from 'next-i18next';
import { useRouter } from 'next/router';
import Icon from './Icon';

const SOC_IMG = [
  { name: '50-x', link: 'social-href_x' },
  { name: '50-telegram', link: 'social-href_telegram' },
  { name: '50-youtube', link: 'social-href_youtube' },
];

const SocialLinks = (props) => {
  const { className } = props;
  const { t } = useTranslation();
  const { locale, asPath } = useRouter();

  const getSocialLink = (linkKey: string) => {
    const isTerminalPage = asPath.startsWith('/terminal');

    if (isTerminalPage) {
      if (locale === 'en') {
        if (linkKey === 'social-href_telegram') return 'https://t.me/tigertrade';
        if (linkKey === 'social-href_youtube')
          return 'https://www.youtube.com/@tigercomglobal?sub_confirmation=1';
        if (linkKey === 'social-href_x') return 'https://x.com/tigercom';
      } else if (locale === 'ru' || locale === 'ua') {
        if (linkKey === 'social-href_telegram') return 'https://t.me/tigercom_ru';
        if (linkKey === 'social-href_youtube')
          return 'https://www.youtube.com/@TigerTrade?sub_confirmation=1';
        if (linkKey === 'social-href_x') return 'https://x.com/tigercom';
      }
    }

    return t(linkKey);
  };

  return (
    <div className={className + ' soc-container'}>
      <p className="soc-title">{t('footer_section3')}</p>
      <div className="soc">
        {SOC_IMG.map(({ name, link }) => {
          if (locale === 'ru' && name === '50-facebook') return null;
          return (
            <a href={getSocialLink(link)} key={name} target="_blank" rel="nofollow noreferrer">
              <Icon name={name} file="sprite" width="50" height="50" />
            </a>
          );
        })}
      </div>
    </div>
  );
};

export default SocialLinks;
